export default __webpack_public_path__ + "static/media/dialogue-africa-ghana-ga-logo.6b8fe236.png";